import { DateRange } from '../../../apis/graphql/types';
import { workWithSessionStorage } from '../../../utils/storages/sessionStorage';
import { StorageEntity } from '../../../utils/storages/storageEntity';
import { ReportFilterStorage } from '../Report/StandardDelivery/types';
import { ReportFilterStorage as DHCReportFilterStorage } from '../Report/StandardDeliveryDHC/types';

export const DATE_RANGE_LABELS = {
  [DateRange.Last_7Days]: 'Last 7 Days',
  [DateRange.CurrentMonth]: 'Current Month',
  [DateRange.CurrentYear]: 'Current Year',
  [DateRange.Custom]: 'Custom Dates',
  [DateRange.LastYear]: 'Campaign Last Year',
  [DateRange.LifeTime]: 'Campaign Lifetime',
  [DateRange.PreviousMonth]: 'Previous Month',
};

export const REPORTS_FILTER_STORAGE_KEY = 'ReportsFilter';

export const storage = new StorageEntity<ReportFilterStorage>(REPORTS_FILTER_STORAGE_KEY, workWithSessionStorage);

export const DHCstorage = new StorageEntity<DHCReportFilterStorage>(REPORTS_FILTER_STORAGE_KEY, workWithSessionStorage);
